module.exports = __webpack_public_path__ + "img/35_14.eb2b84d1.png";